import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Input.scss";

export class Input extends Component {
  render() {
    const {
      label,
      type,
      id,
      placeholder,
      helpText,
      appendItem,
      required,
      hasError,
      className,
      value,
      ...inputProps
    } = this.props;
    // console.log(this.props.required);
    return (
      <div className={`form-group ${hasError ? "has-error" : ""}`}>
        {label ? (
          <label htmlFor={id}>
            {label} {required ? <span className="required">*</span> : null}
          </label>
        ) : null}
        <input
          type={type ? type : "text"}
          className={className ? `form-control ${className}` : "form-control"}
          id={id}
          placeholder={placeholder}
          {...inputProps}
        />
        {helpText ? (
          <small className="form-text text-muted">{helpText}</small>
        ) : null}
      </div>
    );
  }
}

export class ControlledInput extends Component {
  render() {
    const {
      label,
      type,
      id,
      placeholder,
      helpText,
      appendItem,
      required,
      hasError,
      className,
      value,
      ...inputProps
    } = this.props;
    // console.log(this.props.required);
    return (
      <div className={`form-group ${hasError ? "has-error" : ""}`}>
        {label ? (
          <label htmlFor={id}>
            {label} {required ? <span className="required">*</span> : null}
          </label>
        ) : null}
        <input
          type={type ? type : "text"}
          className={className ? `form-control ${className}` : "form-control"}
          id={id}
          placeholder={placeholder}
          value={value || ""}
          {...inputProps}
        />
        {helpText ? (
          <small className="form-text text-muted">{helpText}</small>
        ) : null}
      </div>
    );
  }
}

Input.propTypes = {
  label: PropTypes.string,
  helpText: PropTypes.string,
  placeholder: PropTypes.string
};
